import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import SessionManagementPanel from './pages/session-management-panel';
import AdminLogin from './pages/admin-login';
import VenueSettings from './pages/venue-settings';
import SessionListDashboard from './pages/session-list-dashboard';
import InviteDashboard from './pages/session-list-dashboard/InviteDashboard';
import EventTypeCreatePage from './pages/session-list-dashboard/EventTypeCreatePage';
import LessonTrainingDetailPage from './pages/session-list-dashboard/LessonTrainingDetailPage';
import BracketDashboard from './pages/session-list-dashboard/BracketDashboard';
import BracketBuilder from './pages/session-list-dashboard/BracketBuilder';
import BracketShare from './pages/session-list-dashboard/BracketShare';
import MemberManagement from './pages/member-management';
import PublicSessionPage from './pages/public-session-page';
import SessionCreationWizard from './pages/session-creation-wizard';
import PublicHome from './pages/public-home';
import PublicBracketPage from './pages/public-bracket-page';
import RequireAdmin from './components/RequireAdmin';
import RequireSuperAdmin from './components/RequireSuperAdmin';
import SuperAdminLogin from './pages/super-admin-login';
import SuperAdminAdminsPage from './pages/super-admin-admins';
import ClientSignup from './pages/client-signup';
import ServiceIntroduction from './pages/service-introduction';
import UserAuthentication from './pages/user-authentication';
import UserProfileManagement from './pages/user-profile-management';
import InteractiveEventMap from './pages/interactive-event-map';
import NaverDiscover from './pages/naver-discover';
import EventDetails from './pages/event-details';
import OrganizerDashboard from './pages/organizer-dashboard';
import OpenPlayTools from './pages/openplay-tools';
import RequireUser from './components/RequireUser';
import OpenPlayNotifications from './pages/openplay-notifications';
import OpenPlayParticipatedEvents from './pages/openplay-participated-events';
import OpenPlayCodeManagement from './pages/openplay-code-management';
import OpenPlayCodeFormPage from './pages/openplay-code-management/CodeFormPage';
import RequireProfileAdmin from './components/RequireProfileAdmin';
import OpenPlayCommunityMenu from './pages/openplay-community';
import OpenPlayCommunityBoardPage from './pages/openplay-community/CommunityBoardPage';
import CommunityListPage from './pages/openplay-community/CommunityListPage';
import CommunityFormPage from './pages/openplay-community/CommunityFormPage';
import CommunityDetailPage from './pages/openplay-community/CommunityDetailPage';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ServiceIntroduction />} />
        <Route path="/session-management-panel" element={<RequireAdmin><SessionManagementPanel /></RequireAdmin>} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/venue-settings" element={<RequireAdmin><VenueSettings /></RequireAdmin>} />
        <Route path="/session-list-dashboard" element={<RequireAdmin><SessionListDashboard /></RequireAdmin>} />
        <Route path="/session-list-dashboard/invite" element={<RequireAdmin><InviteDashboard /></RequireAdmin>} />
        <Route path="/session-list-dashboard/event-create/:type" element={<RequireAdmin><EventTypeCreatePage /></RequireAdmin>} />
        <Route path="/session-list-dashboard/lesson-training-detail/:id" element={<RequireAdmin><LessonTrainingDetailPage /></RequireAdmin>} />
        <Route path="/session-list-dashboard/bracket" element={<RequireAdmin><BracketDashboard /></RequireAdmin>} />
        <Route path="/session-list-dashboard/bracket/new" element={<RequireAdmin><BracketBuilder /></RequireAdmin>} />
        <Route path="/session-list-dashboard/bracket/:bracketId" element={<RequireAdmin><BracketBuilder /></RequireAdmin>} />
        <Route path="/bracket-share" element={<BracketShare />} />
        <Route path="/public-bracket" element={<PublicBracketPage />} />
        <Route path="/member-management" element={<RequireAdmin><MemberManagement /></RequireAdmin>} />
        <Route path="/public-session-page" element={<PublicSessionPage />} />
        <Route path="/session-creation-wizard" element={<RequireAdmin><SessionCreationWizard /></RequireAdmin>} />
        <Route path="/openplay/session-creation-wizard" element={<RequireUser><SessionCreationWizard /></RequireUser>} />
        <Route path="/client-signup" element={<ClientSignup />} />
        <Route path="/openplay/service-introduction" element={<ServiceIntroduction />} />
        <Route path="/openplay/user-authentication" element={<UserAuthentication />} />
        <Route path="/openplay/user-profile-management" element={<RequireUser><UserProfileManagement /></RequireUser>} />
        <Route path="/openplay/interactive-event-map" element={<InteractiveEventMap />} />
        <Route path="/openplay/event" element={<NaverDiscover />} />
        <Route path="/openplay/naver-discover" element={<Navigate to="/openplay/event" replace />} />
        <Route path="/openplay/tools" element={<OpenPlayTools />} />
        <Route path="/openplay/participated-events" element={<RequireUser><OpenPlayParticipatedEvents /></RequireUser>} />
        <Route path="/openplay/code-management" element={<RequireProfileAdmin><OpenPlayCodeManagement /></RequireProfileAdmin>} />
        <Route path="/openplay/code-management/new" element={<RequireProfileAdmin><OpenPlayCodeFormPage /></RequireProfileAdmin>} />
        <Route path="/openplay/code-management/:codeId" element={<RequireProfileAdmin><OpenPlayCodeFormPage /></RequireProfileAdmin>} />
        <Route path="/openplay/notifications" element={<RequireUser><OpenPlayNotifications /></RequireUser>} />
        <Route path="/openplay/community" element={<OpenPlayCommunityMenu />} />
        <Route path="/openplay/community/:board" element={<CommunityListPage />} />
        <Route path="/openplay/community/:board/new" element={<CommunityFormPage />} />
        <Route path="/openplay/community/:board/:postId" element={<CommunityDetailPage />} />
        <Route path="/openplay/community/:board/:postId/edit" element={<CommunityFormPage />} />
        <Route path="/openplay/community/legacy" element={<OpenPlayCommunityBoardPage />} />
        <Route path="/openplay/event-details" element={<EventDetails />} />
        <Route path="/openplay/organizer-dashboard" element={<OrganizerDashboard />} />
        <Route path="/super-admin-login" element={<SuperAdminLogin />} />
        <Route path="/super-admin/admins" element={<RequireSuperAdmin><SuperAdminAdminsPage /></RequireSuperAdmin>} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
